export const FinpromVerificationStepKeys = {
  RISK_WARNING: 'riskWarning',
  SELF_CATEGORISATION: 'selfCategorisation',
  APPROPRIATENESS_TEST: 'appropriatenessTest',
} as const

export const FinpromVerificationStepList = Object.values(FinpromVerificationStepKeys)

export const FinpromStepKeys = {
  INITIAL: 'initial',
  ...FinpromVerificationStepKeys,
  COOL_OFF: 'cool-off',
} as const

export const SelfCategorisationStepKeys = {
  SELECT_CATEGORY: 'selectCategory',
  CONFIRM_CATEGORY: 'confirmCategory',
} as const

export const selfCategorisationStepList = Object.values(SelfCategorisationStepKeys)

export const SelfCategorisationCategories = {
  RESTRICTED: 'restricted',
  HIGH_NET_WORTH: 'highNetWorth',
  SOPHISTICATED: 'sophisticated',
} as const

export const selfCategorisationCategoryList = Object.values(SelfCategorisationCategories)

export const SelfCategorisationThreshold = {
  INVESTMENT_PERCENTAGE: 10,
  INCOME: 100000,
  NET_ASSETS: 250000,
} as const

export const YesNoValues = {
  YES: 'yes',
  NO: 'no',
} as const

export const FinpromResult = {
  PASSED: 'passed',
  UNSUCCESSFUL: 'unsuccessful',
} as const

export const FinpromTrackingLabels = {
  INITIAL_MODAL: 'initial modal',
  RISK_WARNING: 'risk warning step',
  SELF_CATEGORISATION_SELECT_CATEGORY: 'self categorisation select category step',
  SELF_CATEGORISATION_CONFIRM_CATEGORY: 'self categorisation confirm category step',
} as const
